import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-camp_color_select",
  "use": "icon-camp_color_select-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol viewBox=\"0 0 16 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-camp_color_select\">\n<path d=\"M2 4.88919L6.62271 9.5119L14.1346 2\" stroke=\"white\" stroke-width=\"2.77363\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol